// - when the viewer wasm encounters a problem while loading a CadFile
// so reading and parsing the gltf mostly, it is considered to be
// a ConversionProblem
// - this class of errors is created when the viewer wasm calls
// viewerControl.logConversionProblem
export class ConversionProblemError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConversionProblemError';
  }
}

// - a LogFailErr is a fatal error that the viewer handled internally,
// and then was passed to the js code to send to sentry
// - this class of errors is created when the viewer wasm calls
// viewerControl.logFaill
export class LogFailError extends Error {
  constructor(message) {
    super(message);
    this.name = 'LogFailError';
  }
}

// - any error created on the js side in the wasmObservable wrappers are
// WasmObservableErrors
export class WasmObservableError extends Error {
  constructor(message) {
    super(message);
    this.name = 'WasmObservableError';
  }
}

// - any error from wasm that is catched in the wasmObservable code is
// created as WasmObservableException, so the WasmObservableError are
// from the js code, WasmObservableException are from the c++ code
export class WasmObservableException extends Error {
  constructor(message) {
    super(message);
    this.name = 'WasmObservableException';
  }
}

// - any exception that is handled in the GltfViewer api code is created
// as GltfViewerException, so these are handled exceptions from the c++
// code, though some may also come from js
// - I assume we are handling all exceptions from c++, if we don't then there
// is no way to handle them other then setting the ABORT_ON_WASM_EXCEPTIONS
// again
export class GltfViewerException extends Error {
  constructor(message) {
    super(message);
    this.name = 'GltfViewerException';
  }
}

// - GltfViewerReload is only for handling when a user clicks reload after
// there was a timeout waiting for the gltf conversions, or after an exception
export class GltfViewerReload extends Error {
  constructor(message) {
    super(message);
    this.name = 'GltfViewerReload';
  }
}
